import { AbstractTranslation } from './AbstractTranslation';

class TemplateTranslation extends AbstractTranslation {
  title1 = {
    en: 'Entity and Environment',
    kana: 'はいけいとぶったい',
  };
  desc1 = {
    en: `This template has a red sphere appears in front of the VR space. Can you make a red sphere blue? In addition, you can select and use a variety of pre-registered backgrounds for the VR background. Let's switch the background.`,
    kana: `このテンプレートをよみこむとあかいきゅうたいがVRくうかんのめのまえにあらわれます。`,
  };

  title2 = {
    en: 'Size and Rotation',
    kana: 'サイズとかいてん',
  };
  desc2 = {
    en: `Use the size attribute to change the size of the object. Specify the magnification in the x: width, y: height, and z: depth directions. Enter a decimal to make it smaller. The rotation attribute specifies how many times to rotate with respect to each of the x-axis, y-axis, and z-axis`,
    kana: `サイズぞくせいをつかうとぶったいの大きさをかえられます。x:よこはば、y:たかさ、z:おくゆきのそれぞれのほうこうへのおおきさをせっていします。ちいさくするには しょうすう でにゅうりょくします。かいてんぞくせいは、xじく、yじく、zじくのそれぞれに どれだけかいてんさせるかをしていします`,
  };

  title3 = {
    en: 'Physics System',
    kana: 'ぶつりエンジン',
  };
  desc3 = {
    en: `To apply gravity to an object or to express a collision between objects, add the “Dynamic body” attribute to the object from the category of the Physics System. Set the “Static body” attribute to the floor or wall.`,
    kana: `ぶったいにじゅうりょくをかけたり、ぶったいどうしのぶつかりをひょうげんするにはぶつりエンジンのカテゴリから「うごきのあるぶっしつにする」ぞくせいをぶったいについかします。「うごきのないぶったいにする」ぞくせいは、ゆかやかべなどにせっていします。`,
  };

  title4 = {
    en: 'Repeat Block',
    kana: 'くりかえしブロック',
  };
  desc4 = {
    en: `Using a repeate block can produce many of the same blocks.`,
    kana: `くりかえしブロックをつかうとおなじブロックをたくさんつくりだすことができます。`,
  };

  title5 = {
    en: 'Use variables to determine size',
    kana: 'サイズをきめるためにへんすうをつかう',
  };
  desc5 = {
    en: `A “variable” is a value that you can remember. To use a variable, start the item with '='. `,
    kana: `「へんすう」は あたい をおぼえておくことができるものです。へんすうをつかうにはこうもくのかきはじめを「=」にします。`,
  };

  title6 = {
    en: 'Creating and using many variables',
    kana: 'たくさんのへんすうのさくせいとりよう',
  };
  desc6 = {
    en: `If you create a variable in a block that sets a value in the variable, you can use it in the input items of each block. When you start writing with '=', the input item means 'take out and use the value in the variable'.`,
    kana: `へんすうに あたい をセットするブロックでへんすうをつくると、かくブロックのにゅうりょくこうもくでりようするとができます。「=」でかきはじめるとそのにゅうりょくこうもくは「へんすうのなかの あたい をとりだしてつかう」といういみになります。`,
  };

  title7 = {
    en: 'AR',
    kana: 'AR',
  };
  desc7 = {
    en: `To use AR, attach the AR setting attribute to the scene. When an object is placed as a child element of an AR marker, it reacts to the marker and appears on the camera.`,
    kana: `ARをつかうには、シーンにARのせっていようぞくせいをつけます。ARマーカーのこようそとしてぶったいをはいちするとマーカーにはんのうしてカメラ上にとうじょうします。`,
  };

  title8 = {
    en: 'Respond to multiple markers with AR',
    kana: 'ARでふくすうのマーカーにはんのうする',
  };
  desc8 = {
    en: `Respond to multiple markers in AR mode`,
    kana: `ARモードでふくすうのマーカーにはんのうするようにします`,
  };

  title9 = {
    en: 'Block tower battle',
    kana: 'ブロックタワーバトル',
  };
  desc9 = {
    en: `It is the foundation part of the game that piles up the blocks`,
    kana: `ブロックをつみあげていくゲームのどだいぶぶんです`,
  };

  title10 = {
    en: 'Lighted room',
    kana: 'ライトのともったへや',
  };
  desc10 = {
    en: `A room with a depth of 30, a width of 30 and a height of 10 is equipped with one point light.This wall cannot slip through. To create a wall that wont slip through, add a camera to your scene by adding a stationary object attribute to the wall.`,
    kana: `おくゆき３０、はば３０、たかさ１０のへやにポイントライトを一つつけました。このかべは、とおりぬけることができません。こんなかべをつくるには、かべに「せいししたぶったい」のぞくせいをつけて、カメラをシーンについかします。`,
  };

  title11 = {
    en: 'AR without marker',
    kana: 'マーカーなしのAR',
  };
  desc11 = {
    en: `You can also make AR without markers. Let's set the AR setting attribute in the scene and place the object.`,
    kana: `マーカーなしでARをつくることもできます。シーンにARのせっていようぞくせいをせっていしてぶったいをはいちしてみましょう。`,
  };

  title12 = {
    en: 'Random block',
    kana: 'ランダムブロック',
  };
  desc12 = {
    en: `Use random attributes to add randomness to object . By combining it with a loop, you can create accidental fun.`,
    kana: `ランダムぞくせいをつかうとぶったいのはいちにランダムせいをもたせることができます。ループとくみあわせることでぐうはつてきなおもしろさをつくることができます。`,
  };

  title13 = {
    en: 'Jenga',
    kana: 'ジェンガ',
  };
  desc13 = {
    en: `Pull out the blocks from the 3 row x 7 row VR Jenga and stack them on top.
		Read the program and come up with a strategy that will allow you to stack the highest blocks.
		Please read the 3 minute program first. “What is the top Y axis?” “Where can I change the block to move up?”.
		Then play in 5 minutes. Please work together as a pair of two.`,
    kana: `3れつと7だんで くみたてられたVRジェンガからブロックをぬいて、うえにつみあげていきましょう。
		プログラムをよんでイメージして、いちばんたかくジェンガをつみあげるにはどうすればいいかかんがえてください。
		まずは3ふんプログラムをよんでみてください。「いちばんうえのYはいくつでしょう？」「どこをかえたらブロックをうえにうごかせるでしょう？」。そのあと５分でプレイします。ぜひ ふたりひとくみ になってそうだんしながらやってみてください。`,
  };

  title14 = {
    en: 'step point',
    kana: 'とびのれるキューブ',
  };
  desc14 = {
    en: `You can jump on the cube by hovering the gazing cursor over the floating cubes.`,
    kana: `うかんだキューブにまんなかのカーソルをあわせると、キューブにとび乗ることができます。`,
  };

  title15 = {
    en: 'Space sharing',
    kana: 'くうかんきょうゆう（かいわができる）',
  };
  desc15 = {
    en: `You can create a space where you can enter with other people by setting the scene to space sharing (calling is possible) and using the camera block. You can enter the same space by sharing the URL with others.`,
    kana: `シーンのせっていをくうかんきょうゆうにして、カメラブロックをつかうことでほかのひとといっしょにはいるくうかんをつくることができます。URLをほかのひとにきょうゆうするとおなじじくうかんにはいることができます。`,
  };

  title16 = {
    en: 'Movie',
    kana: 'どうがさいせい',
  };
  desc16 = {
    en: `You can embed the video in VR or AR ,By uploading a video on the file manager and adding it as a block. `,
    kana: `ファイルかんりがめんでどうがをアップロードしてブロックとしてついかすることで、VRやARにどうがをくみこむことができます。`,
  };

  title17 = {
    en: 'Audio play',
    kana: 'おんせいさいせい',
  };
  desc17 = {
    en: `By uploading music files on the file management screen and adding them as blocks, you can incorporate music and sound effects into VR and AR. Audio playback must be allowed if autoplay is selected.`,
    kana: `ファイルかんりがめんでおんがくファイルをアップロードしてブロックとしてついかすることで、VRやARにおんがくやこうかおんをくみこむことができます。じどうさいせいをせんたくしているときは、きょかをしてください`,
  };

  title18 = {
    en: 'Hit Test',
    kana: 'ぶつかったとき',
  };
  desc18 = {
    en: `Click on the sphere to pop it out and see the Hit text when you hit the blue block.`,
    kana: 'ボールをクリックするととびだして、あおいブロックにぶつかったときにHitのもじが でてきます',
  };

  title19 = {
    en: 'CODE Mode',
    kana: 'コードモード',
  };
  desc19 = {
    en: `You can write JavaScript programs for VR and AR in the CODE tab.`,
    kana: 'CODEのタブでVRやARくうかんをそうさする、JavaScriptのプログラムをかくことができます',
  };
  title20 = {
    en :`Swimming a fish in your tank! (Beginner)`,
    kana:`すいそうで、おさかなをおよがそう！(はじめてのひと)`
  };
  desc20 = {
    en :`To make a tank, using BLOCK of "BOX" & "Opacity". For a fish, you can select 3D model of "Fish02" from Preset menu. And then you can move your fish from left to right  in the tank with Javascript code.`,
    kana:`3Dモデルのおさかなを、BLOCKでつくったすいそうにいれて、Javascriptのプログラムでいどうさせます`
  };
  title21 = {
    en :`Swimming fish in your tank! (Normal1)`,
    kana:`すいそうで、おさかなをたくさんおよがそう！(うまくなりたいひと1)`
  };
  desc21 = {
    en :`To make a tank, using BLOCK of "BOX" & "Opacity". For fish, you can select 3D model of "Fish02" from Preset menu. And then you can move your fish from right to left in the tank with Javascript code.`,
    kana:`3Dモデルのおさかなたちを、BLOCKでつくったすいそうにいれて、Javascriptのプログラムでいどうさせます`
  };
  title22 = {
    en :`Electronic message board (Current time).`,
    kana:`ひらがな: でんこうけいじばん(きょうのじかん)`
  };

  desc22 = {
    en :`Create an electronic message board using cubes and text, and display the current time on it.`,
    kana:`はことテキストをつかって、でんこうけいじばんをつくり、きょうのじかんをひょうじします`
  };

  title23 = {
    en :`Warp button`,
    kana:`わーぷぼたん`
  };
  desc23 = {
    en :`It is a JavaScript program that can switch the background of the sphere photo with the warp button.`,
    kana:`ぜんてんきゅうのはいけいをわーぷぼたんできりかえることができるJavaScriptのぷろぐらむです`
  };

  title24 = {
    en :`Birthday card`,
    kana:`たんじょうびかーど`
  };
  desc24 = {
    en :`It's a VR birthday card. Let's change the name and photo and make a birthday card just for that person and give it as a gift.`,
    kana:`VRのたんじょうびカードです、なまえしゃしんをへんこうしてそのひとのためだけのたんじょうびカードをつくってプレゼントしてみましょう`
  };

  title_nttd01 = {
    en: 'repeat block',
    kana: 'くりかえしブロック',
  };
  desc_nttd01 = {
    en: 'You can create a lot of the same blocks by using the repeated blocks.',
    kana: 'くりかしブロックをつかうとおなじブロックをたくさんつくりだすことができます。',
  };
}

export const template_translation = new TemplateTranslation();
